import { useState, useEffect } from "react";
import axios from "axios";
import UsersTab from "../UsersTab";
import { useTranslation } from 'react-i18next';
import { AiOutlineTeam, AiOutlineCheckCircle, AiOutlineUserAdd, AiOutlineSafetyCertificate } from "react-icons/ai";

const UsersPage = () => {
  const { t } = useTranslation();

  const [users, setUsers] = useState([]);
  const [roleFilter, setRoleFilter] = useState("all");

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await axios.get("/api/users", { 
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } 
      });
      setUsers(response.data);
    } catch (error) {
      console.error("Помилка отримання користувачів:", error);
    }
  };

  const countAll = users.length;
  const countActive = users.filter((u) => u.role === "user").length;
  const countNew = users.filter((u) => u.role === "new").length;
  const countAdmins = users.filter((u) => u.role === "admin").length;

  const filters = [
    { id: "all", label: t("all"), count: countAll, icon: AiOutlineTeam, variant: "primary" },
    { id: "user", label: t("activeFilter"), count: countActive, icon: AiOutlineCheckCircle, variant: "success" },
    { id: "new", label: t("new"), count: countNew, icon: AiOutlineUserAdd, variant: "warning" },
    { id: "admin", label: t("administrators"), count: countAdmins, icon: AiOutlineSafetyCertificate, variant: "danger" },
  ];

  return (
    <div className="container-fluid mt-5 px-4">
      {/* Фільтри: на мобільному — колонка (1 кнопка в ряд), на планшеті/десктопі — ряд */}
      <div className="d-flex flex-column flex-md-row mb-4" style={{ gap: "8px" }}>
        {filters.map(({ id, label, count, icon: Icon, variant }) => (
          <div
            key={id}
            className="border rounded px-3 py-2 d-flex align-items-center justify-content-center gap-2 text-decoration-none text-dark flex-grow-1 w-100"
            style={{
              flex: "1 1 0",
              minWidth: 0,
              cursor: "pointer",
              backgroundColor: roleFilter === id ? `var(--bs-${variant})` : undefined,
              color: roleFilter === id ? "white" : undefined,
              borderColor: roleFilter === id ? `var(--bs-${variant})` : undefined,
            }}
            onClick={() => setRoleFilter(id)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && setRoleFilter(id)}
          >
            <Icon size={20} className="flex-shrink-0" />
            <span className="fw-semibold">{label}</span>
            <span className={roleFilter === id ? "opacity-90" : "text-muted"} style={{ fontSize: "1rem" }}>{count}</span>
          </div>
        ))}
      </div>

      <div className="container">
      <UsersTab users={users} fetchUsers={fetchUsers} roleFilter={roleFilter} setRoleFilter={setRoleFilter} />
   
   
      </div>
    </div>
  );
};

export default UsersPage;
